'use strict';
define(['app', 'angular'], function (app, angular) {
    app.directive('stUiButton', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var variants = ['primary', 'outline', 'ghost', 'error'];
                function applyClasses() {
                    element.addClass('dui-btn');
                    if (variants.indexOf(attrs.stUiButton) !== -1) {
                        element.addClass('dui-btn-' + attrs.stUiButton);
                    }
                }
                applyClasses();
                attrs.$observe('class', applyClasses);
                if (!attrs.type) { attrs.$set('type', 'button'); }
            }
        };
    });
    app.directive('stUiIndeterminate', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(attrs.stUiIndeterminate, function (value) {
                    element[0].indeterminate = Boolean(value);
                });
            }
        };
    });
    app.directive('stUiDropdown', ['$document', '$window', function ($document, $window) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var details = element[0];
                function placePanel() {
                    if (!details.open) { return; }
                    var panel = details.querySelector('.dui-dropdown-content');
                    var trigger = details.querySelector('summary').getBoundingClientRect();
                    var width = Math.min(260, $window.innerWidth - 24);
                    panel.style.position = 'fixed';
                    panel.style.width = width + 'px';
                    panel.style.left = Math.max(12, Math.min(trigger.left, $window.innerWidth - width - 12)) + 'px';
                    panel.style.right = 'auto';
                    panel.style.top = (trigger.bottom + 6) + 'px';
                    panel.style.maxHeight = Math.max(120, $window.innerHeight - trigger.bottom - 18) + 'px';
                }
                function closeOutside(event) {
                    if (details.open && !details.contains(event.target)) { details.open = false; }
                }
                function closeOnEscape(event) {
                    if (event.key === 'Escape' && details.open) {
                        details.open = false;
                        details.querySelector('summary').focus();
                        event.stopPropagation();
                    }
                }
                $document.on('click', closeOutside);
                element.on('keydown', closeOnEscape);
                element.on('toggle', placePanel);
                angular.element($window).on('resize', placePanel);
                scope.$on('$destroy', function () {
                    $document.off('click', closeOutside);
                    element.off('keydown', closeOnEscape);
                    element.off('toggle', placePanel);
                    angular.element($window).off('resize', placePanel);
                });
            }
        };
    }]);
});
